import { usePortfolioSize } from "./PortfolioSizeContext";

const MAX_PORTFOLIO_SIZE = 5000000;
const MIN_PORTFOLIO_SIZE = 50000;

export const PortfolioSizeControls = () => {
  const { portfolioSize, setPortfolioSize, inputValue, setInputValue } = usePortfolioSize();

  const handleSliderChange = (value: number[]) => {
    setPortfolioSize(value[0]);
    setInputValue(value[0].toString());
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.replace(/[^0-9]/g, '');
    setInputValue(value);
    
    if (value) {
      const numericValue = parseInt(value);
      if (!isNaN(numericValue)) {
        if (numericValue >= MIN_PORTFOLIO_SIZE && numericValue <= MAX_PORTFOLIO_SIZE) {
          setPortfolioSize(numericValue);
        }
      }
    }
  };

  const handleInputBlur = () => {
    const numericValue = parseInt(inputValue);
    if (!inputValue || isNaN(numericValue)) {
      setInputValue(portfolioSize.toString());
    } else {
      const clampedValue = Math.min(Math.max(numericValue, MIN_PORTFOLIO_SIZE), MAX_PORTFOLIO_SIZE);
      setPortfolioSize(clampedValue);
      setInputValue(clampedValue.toString());
    }
  };

  return {
    handleSliderChange,
    handleInputChange,
    handleInputBlur,
    MAX_PORTFOLIO_SIZE,
    MIN_PORTFOLIO_SIZE,
  };
};